import { render, staticRenderFns } from "./AssignStaffForm.vue?vue&type=template&id=e376b72a&"
import script from "./AssignStaffForm.vue?vue&type=script&lang=js&"
export * from "./AssignStaffForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports